module.exports = {"pagination":{}}


//////////////////
// WEBPACK FOOTER
// ../~/aws-sdk/apis/cognito-idp-2016-04-18.paginators.json
// module id = 273
// module chunks = 0